module.exports = __webpack_public_path__ + "static/media/HarlanEvans_Resume_PDF.e8eadbb5.pdf";